import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ReactNode } from "react";

interface Props {
  open: boolean;
  title: string;
  content: string | ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

export const Dialogs = ({
  open,
  title,
  content,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <>
      <Dialog
        className="dialog"
        open={open}
        onClose={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={""}>
          <Button onClick={onCancel} variant="outlined" autoFocus>
            取消
          </Button>
          <Button onClick={onConfirm} variant="contained" autoFocus>
            确认
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
